import http from './http'
import {
  API_JOBS_ENDPOINT,
  API_SCHEDULED_JOBS_ENDPOINT,
  API_JOBS_ROLLUP_ENDPOINT,
  API_JOB_CREATE_ENDPOINT,
  API_JOB_LEAD_SEARCH_ENDPOINT,
  API_FIND_EMAIL_ENDPOINT,
  API_VERIFY_EMAIL_ENDPOINT,
  API_CRM_VERIFY_EMAIL_ENDPOINT,
  API_BOTS_ENDPOINT,
  API_BOT_OPTIONS_ENDPOINT,
  API_BOT_PAUSE_ENDPOINT,
  API_PROXIES_ENDPOINT,
  API_PLAYBOOK_ENDPOINT,
  API_USER_ENDPOINT,
  API_USER_SETTINGS_ENDPOINT,
  API_PAYMENT_METHOD_ENDPOINT,
  API_CREDIT_ENDPOINT,
  API_AUTO_RECHARGE_ENDPOINT,
  API_SUBSCRIPTION_ENDPOINT,
  API_APIKEY_ENDPOINT,
  API_WEBHOOK_ENDPOINT,
  API_WEBHOOK_TEST_ENDPOINT,
  API_LPDEFENDER_ENDPOINT,
  API_INVOICES_ENDPOINT,
  API_INVOICE_DOWNLOAD_ENDPOINT,
  API_INTEGRATIONS_ENDPOINT, 
  API_VERIFY_EMAIL_CSV_ENDPOINT, 
  API_FIND_EMAIL_CSV_ENDPOINT,
  API_ACTIVITY_REQUESTSPERDAY_ENDPOINT,
  API_ACTIVITY_FINDEMAILSUCCESSPERCENTAGE_ENDPOINT,
  API_ACTIVITY_VERIFYEMAILOUTCOMES_ENDPOINT,
  API_PAYMENT_NOTIFICATIONSETTINGS_ENDPOINT,
  API_ACTIVITY_JOBCOST_ENDPOINT,
  API_ACTIVITY_EXECUTIONTIME_ENDPOINT,
  API_ACTIVITY_QUEUEDTIME_ENDPOINT,
  API_SETUP_INTENT_ENDPOINT,
  API_3DS_CONFIRM_ENDPOINT,
  API_REFERRAL_CODE_ENDPOINT,
  API_PROMO_CODE_ENDPOINT,
  API_INVOICE_SETTINGS_ENDPOINT,
  API_PROMO_APPLICATION_ENDPOINT,
  API_USER_FP_ENDPOINT,
  API_FORM_DEFENDER_PREMIUM_ENDPOINT,
  API_PRICING_TIER_ENDPOINT,
  API_AFFILIATE_TRANSACTIONS_ENDPOINT,
  API_AFFILIATE_REFERRALS_ENDPOINT,
  API_AFFILIATE_DISCOUNT_DAYS_ENDPOINT,
  API_BILLED_REQUESTS_ENDPOINT,
} from './_constants'


export const getReportsActivityByDay = async (params = {}) => {
  const response = await http.get(API_ACTIVITY_REQUESTSPERDAY_ENDPOINT, {
    params: params,
  })
  return response.data
}

export const getReportsFindEmailSuccessPercentageByDay = async (params = {}) => {
  const response = await http.get(API_ACTIVITY_FINDEMAILSUCCESSPERCENTAGE_ENDPOINT, {
    params: params,
  })
  return response.data
}

export const getReportsVerifyEmailOutcomesByDay= async (params = {}) => {
  const response = await http.get(API_ACTIVITY_VERIFYEMAILOUTCOMES_ENDPOINT, {
    params: params,
  })
  return response.data
}

export const getReportsJobCostByDay= async (params = {}) => {
  const response = await http.get(API_ACTIVITY_JOBCOST_ENDPOINT, {
    params: params,
  })
  return response.data
}

export const getReportsExecutionTime= async (params = {}) => {
  const response = await http.get(API_ACTIVITY_EXECUTIONTIME_ENDPOINT, {
    params: params,
  })
  return response.data
}

export const getReportsQueuedTime= async (params = {}) => {
  const response = await http.get(API_ACTIVITY_QUEUEDTIME_ENDPOINT, {
    params: params,
  })
  return response.data
}


export const getJobs = async (params = {}) => {
  const response = await http.get(API_JOBS_ENDPOINT, {
    params: params,
  })
  return response.data
}

export const getScheduledJobs = async (params = {}) => {
  const response = await http.get(API_SCHEDULED_JOBS_ENDPOINT, {
    params: params,
  })
  return response.data
}

export const getJobRollup = async (params = {}) => {
  const response = await http.get(API_JOBS_ROLLUP_ENDPOINT)
  return response.data
}

export const createJob = async (data) => {
  const response = await http.post(API_JOB_CREATE_ENDPOINT, data)
  return response.data
}

export const createLeadSearchJob = async (data) => {
  const response = await http.post(API_JOB_LEAD_SEARCH_ENDPOINT, data)
  return response.data
}

export const findEmail = async (data) => {
  const response = await http.post(API_FIND_EMAIL_ENDPOINT, data)
  return response.data
}

export const verifyEmail = async (data) => {
  const response = await http.post(API_VERIFY_EMAIL_ENDPOINT, data)
  return response.data
}

export const verifyEmailCRM = async (data) => {
  const response = await http.post(API_CRM_VERIFY_EMAIL_ENDPOINT, data)
  return response.data
}

export const verifyEmailCSV = async (data) => {
  const response = await http.post(API_VERIFY_EMAIL_CSV_ENDPOINT, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export const findEmailCSV = async (data) => {
  const response = await http.post(API_FIND_EMAIL_CSV_ENDPOINT, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export const testVerifyEmailCRM = async (data, url) => {
  const response = await http.post(url, data)
  return response.data
}

export const editJob = async (data) => {
  const response = await http.put(API_JOBS_ENDPOINT, data)
  return response.data
}

export const auditJob = async (url) => {
  const response = await http.get(url)
  return response.data
}

export const deleteJob = async (id) => {
  const response = await http.delete(API_JOBS_ENDPOINT, {
    data: { id: id },
  })
  return response.data
}

export const getBots = async () => {
  const response = await http.get(API_BOTS_ENDPOINT)
  return response.data
}

export const getBotOptions = async () => {
  const response = await http.get(API_BOT_OPTIONS_ENDPOINT)
  return response.data
}

export const createBot = async (data) => {
  const response = await http.post(API_BOTS_ENDPOINT, data)
  return response
}

export const editBot = async (data) => {
  const response = await http.put(API_BOTS_ENDPOINT, data)
  return response.data
}

export const deleteBot = async (id) => {
  const response = await http.delete(API_BOTS_ENDPOINT, {
    data: { id: id },
  })
  return response.data
}

export const pauseBot = async (id) => {
  const response = await http.put(
    API_BOT_PAUSE_ENDPOINT,
    {
      botId: id,
      pause: true,
    },
  )
  return response.data
}

export const unpauseBot = async (id) => {
  const response = await http.put(
    API_BOT_PAUSE_ENDPOINT,
    {
      botId: id,
      pause: false,
    },
  )
  return response.data
}

export const getProxies = async () => {
  const response = await http.get(API_PROXIES_ENDPOINT)
  return response.data
}

export const getPlaybooks = async () => {
  const response = await http.get(API_PLAYBOOK_ENDPOINT)
  return response.data
}

export const createPlaybook = async (data) => {
  const response = await http.post(API_PLAYBOOK_ENDPOINT, data)
  return response
}

export const editPlaybook = async (data) => {
  const response = await http.put(API_PLAYBOOK_ENDPOINT, data)
  return response.data
}

export const deletePlaybook = async (id) => {
  const response = await http.delete(API_PLAYBOOK_ENDPOINT, {
    data: { id: id },
  })
  return response.data
}

export const getUsers = async () => {
  const response = await http.get(API_USER_ENDPOINT)
  return response.data
}

export const createUser = async (data) => {
  const response = await http.post(API_USER_ENDPOINT, data)
  return response
}

export const editUser = async (data) => {
  const response = await http.put(API_USER_ENDPOINT, data)
  return response.data
}

export const deleteUser = async (id) => {
  const response = await http.delete(API_USER_ENDPOINT, {
    data: { id: id },
  })
  return response.data
}

export const getInvoices = async () => {
  const response = await http.get(API_INVOICES_ENDPOINT)
  return response.data
}

export const downloadInvoice = async (id) => {
  const url = `${API_INVOICE_DOWNLOAD_ENDPOINT}?id=${id}`;
  const response = await http.get(url)
  return response.data
}

export const getPaymentMethods = async () => {
  const response = await http.get(API_PAYMENT_METHOD_ENDPOINT)
  return response.data
}

export const addPaymentMethod = async (data) => {
  const response = await http.post(API_PAYMENT_METHOD_ENDPOINT, { stripeId: data.id })
  return response.data
}

export const deletePaymentMethod = async (id) => {
  const response = await http.delete(API_PAYMENT_METHOD_ENDPOINT, {
    data: { stripeId: id },
  })
  return response.data
}

export const getCredit = async () => {
  const response = await http.get(API_CREDIT_ENDPOINT)
  return response.data
}

export const addCredit = async (data) => {
  console.log('Making API call with data:', data);
  const response = await http.post(API_CREDIT_ENDPOINT, data);
  console.log('Raw API response:', response);
  console.log('API response data:', response.data);
  const responseData = response.data;
  console.log('About to return:', responseData);
  return responseData;
}

export const getAutoRechargeSettings = async () => {
  const response = await http.get(API_AUTO_RECHARGE_ENDPOINT)
  return response.data
}

export const updateAutoRechargeSettings = async (data) => {
  const response = await http.post(API_AUTO_RECHARGE_ENDPOINT, data)
  return response.data
}

export const deleteAutoRechargeSettings = async () => {
  const response = await http.delete(API_AUTO_RECHARGE_ENDPOINT, {})
  return response.data
}


export const getSubscription = async () => {
  const response = await http.get(API_SUBSCRIPTION_ENDPOINT)
  return response.data
}

export const setSubscription = async (data) => {
  const response = await http.post(API_SUBSCRIPTION_ENDPOINT, data)
  return response.data
}

export const getApiKey = async () => {
  const response = await http.get(API_APIKEY_ENDPOINT)
  return response.data
}

export const rollApiKey = async () => {
  const response = await http.post(API_APIKEY_ENDPOINT, { rollKey: true })
  return response.data
}

export const getWebhookUrl = async () => {
  const response = await http.get(API_WEBHOOK_ENDPOINT)
  return response.data
}

export const updateWebhookUrl = async (webhookUrl) => {
  const response = await http.post(API_WEBHOOK_ENDPOINT, { webhookURL: webhookUrl })
  return response.data
}

export const testWebhook = async () => {
  const response = await http.get(API_WEBHOOK_TEST_ENDPOINT)
  return response.data
}

export const getIntegrations = async () => {
  const response = await http.get(API_INTEGRATIONS_ENDPOINT)
  return response.data
}

export const disconnectIntegration = async (apiName) => {
  const response = await http.delete(API_INTEGRATIONS_ENDPOINT, {
    data: { integration: apiName },
  })
  return response.data
}

export const getIntegrationSchema = async (url) => {
  const response = await http.get(url)
  return response.data
}

export const getLPDefenderCode = async (params) => {
  const response = await http.get(API_LPDEFENDER_ENDPOINT, {
    params: params,
  })
  return response.data
}

export const getUserSettings = async () => {
  return await http.get(API_USER_SETTINGS_ENDPOINT)
}

export const sendFingerprint = async (fp, additionalParams = {}) => {
  return await http.post(API_USER_FP_ENDPOINT, { fp, ...additionalParams })
}

export const getSSFPSFingerprint = async () => {
  try {
    const response = await fetch('https://ssfps.trykitt.ai/api/fp', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`SSFPS API request failed: ${response.status}`);
    }
    
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('SSFPS fingerprint request failed:', error);
    return { success: false, error: error.message };
  }
}

export const getNotificationSettings = async () => {
  const response = await http.get(API_PAYMENT_NOTIFICATIONSETTINGS_ENDPOINT)
  return response.data
}

export const updateNotificationSettings = async (data) => {
  const response = await http.post(API_PAYMENT_NOTIFICATIONSETTINGS_ENDPOINT, data)
  return response.data
}

export const deleteNotificationSettings = async () => {
  const response = await http.delete(API_PAYMENT_NOTIFICATIONSETTINGS_ENDPOINT, {})
  return response.data
}

export const createSetupIntent = async () => {
  const response = await http.post(API_SETUP_INTENT_ENDPOINT)
  return response.data
}

export const confirm3DS = async (data) => {
  const response = await http.post(API_3DS_CONFIRM_ENDPOINT, data)
  return response.data
}

export const getReferralCode = async () => {
  const response = await http.get(API_REFERRAL_CODE_ENDPOINT)
  return response.data
}

export const redeemPromoCode = async (code) => {
  const response = await http.post(API_PROMO_CODE_ENDPOINT, { promoCode: code })
  return response.data
}

export const getInvoiceSettings = async () => {
  const response = await http.get(API_INVOICE_SETTINGS_ENDPOINT)
  return response.data
}

export const updateInvoiceSettings = async (data) => {
  const response = await http.post(API_INVOICE_SETTINGS_ENDPOINT, data)
  return response.data
}

export const uploadPartnerFiles = async (formData) => {
  const response = await http.post(API_PROMO_APPLICATION_ENDPOINT, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export const setFormDefenderPremium = async (isPremium) => {
  const response = await http.post(API_FORM_DEFENDER_PREMIUM_ENDPOINT, {
    premium: isPremium
  })
  return response.data
}

export const getFormDefenderPremiumStatus = async () => {
  const response = await http.get(API_FORM_DEFENDER_PREMIUM_ENDPOINT)
  return response.data
}

export const getPricingTier = async () => {
  const response = await http.get(API_PRICING_TIER_ENDPOINT)
  return response.data
}

export const getAffiliateTransactions = async () => {
  const response = await http.get(API_AFFILIATE_TRANSACTIONS_ENDPOINT)
  return response.data
}

export const claimAffiliateCredit = async (action, amount) => {
  const response = await http.post(API_AFFILIATE_TRANSACTIONS_ENDPOINT, {
    action: action,
    amount: amount
  })
  return response.data
}

export const getAffiliateReferrals = async () => {
  const response = await http.get(API_AFFILIATE_REFERRALS_ENDPOINT)
  return response.data
}

export const getAffiliateDiscountDaysRemaining = async () => {
  console.log('API: getAffiliateDiscountDaysRemaining called')
  try {
    const response = await http.get(API_AFFILIATE_DISCOUNT_DAYS_ENDPOINT)
    console.log('API: response received:', response)
    return response.data
  } catch (error) {
    console.error('API: Error in getAffiliateDiscountDaysRemaining:', error)
    throw error
  }
}

export const getBilledRequests = async () => {
  const response = await http.get(API_BILLED_REQUESTS_ENDPOINT)
  return response.data
}